import { useSyncExternalStore } from "react";

import { importDraft } from "@/lib/order-import/draft";

/** Filled rows of the unfinished import list, live. Kept apart so the dashboard's
 *  «Продолжить загрузку (N)» doesn't pull the import code into the main bundle. */
export function useDraftRowCount(): number {
  return useSyncExternalStore(importDraft.subscribe, importDraft.filledRows);
}
